/**
 * @generated SignedSource<<2eb27e14fc674cad29b6b8de9001855c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteInvoiceDialog_invoice$data = {
  readonly customerAccount: {
    readonly customerName: string;
  };
  readonly id: string;
  readonly " $fragmentType": "DeleteInvoiceDialog_invoice";
};
export type DeleteInvoiceDialog_invoice$key = {
  readonly " $data"?: DeleteInvoiceDialog_invoice$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteInvoiceDialog_invoice">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteInvoiceDialog_invoice",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomerAccount",
      "kind": "LinkedField",
      "name": "customerAccount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customerName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Invoice",
  "abstractKey": null
};

(node as any).hash = "685e7e3fee50b1966a7e09c7e4c58eaa";

export default node;
